// Salary data extracted from "salary data.xlsx"
// All numeric values are in 万円 (10,000 yen units)

// Position keys in order: PM, PL, RD (Requirements Definition), BD (Basic Design),
// DD (Detailed Design), IMPL (Implementation/Infrastructure), OPS (Operations), TEST (Testing)
export const POSITION_KEYS = ["pm", "pl", "rd", "bd", "dd", "impl", "ops", "test"];

// Experience keys in order (1-2 years through 10+ years)
export const EXPERIENCE_KEYS = [
  "1-2", "2-3", "3-4", "4-5", "5-6",
  "6-7", "7-8", "8-9", "9-10", "10+",
];

// Position-specific range width (±width) used for Min-Max display
export const POSITION_WIDTHS = {
  pm: 50,
  pl: 40,
  rd: 40,
  bd: 30,
  dd: 30,
  impl: 30,
  ops: 20,
  test: 20,
};

// Minimum wage floor (万円)
export const MINIMUM_SALARY = 236;

// Skills data — each skill has its own base salary, position bonuses/caps,
// and experience bonuses/caps (values from Sheet 1 of salary data.xlsx)
// positionBonuses: [PM, PL, RD, BD, DD, IMPL, OPS] (TEST bonus is always 0)
// positionCaps:    [PM, PL, RD, BD, DD, IMPL, OPS, TEST]
// expBonuses:      per-year increments for [2-3, 3-4, 4-5, 5-6, 6-7, 7-8, 8-9, 9-10, 10+]
// expCaps:         cap for each experience level [1-2, 2-3, ..., 10+]
export const SKILLS = [
  {
    id: "c_lang",
    nameKey: "salary_page.skills.c_lang",
    categoryKey: "salary_page.categories.programming",
    base: 336,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 690],
  },
  {
    id: "html_css",
    nameKey: "salary_page.skills.html_css",
    categoryKey: "salary_page.categories.programming",
    base: 300,
    positionBonuses: [90, 90, 96, 96, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 36, 36, 36, 24, 12, 12, 12],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "javascript",
    nameKey: "salary_page.skills.javascript",
    categoryKey: "salary_page.categories.programming",
    base: 300,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "sql",
    nameKey: "salary_page.skills.sql",
    categoryKey: "salary_page.categories.programming",
    base: 324,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "cloud",
    nameKey: "salary_page.skills.cloud",
    categoryKey: "salary_page.categories.infrastructure",
    base: 324,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "sap",
    nameKey: "salary_page.skills.sap",
    categoryKey: "salary_page.categories.infrastructure",
    base: 360,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 690],
  },
  {
    id: "postgresql",
    nameKey: "salary_page.skills.postgresql",
    categoryKey: "salary_page.categories.infrastructure",
    base: 324,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "oracle",
    nameKey: "salary_page.skills.oracle",
    categoryKey: "salary_page.categories.infrastructure",
    base: 324,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "lan_wan",
    nameKey: "salary_page.skills.lan_wan",
    categoryKey: "salary_page.categories.infrastructure",
    base: 324,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
  {
    id: "server_ops",
    nameKey: "salary_page.skills.server_ops",
    categoryKey: "salary_page.categories.infrastructure",
    base: 324,
    positionBonuses: [90, 90, 84, 84, 72, 72, 36],
    positionCaps: [690, 690, 636, 636, 624, 624, 438, 432],
    expBonuses: [24, 48, 24, 24, 48, 24, 12, 12, 24],
    expCaps: [420, 500, 500, 550, 550, 600, 600, 648, 648, 648],
  },
];

// Position bonus for a given skill and position key.
// TEST position bonus is always 0 (not stored in positionBonuses array).
export function getPositionBonus(skill, positionKey) {
  if (positionKey === "test") return 0;
  const idx = POSITION_KEYS.indexOf(positionKey);
  return skill.positionBonuses[idx] ?? 0;
}

export function getPositionCap(skill, positionKey) {
  const idx = POSITION_KEYS.indexOf(positionKey);
  return skill.positionCaps[idx] ?? 0;
}

// Cumulative experience bonus up to the selected experience level.
// 1-2 years has no bonus (index 0); bonuses apply from 2-3 onwards.
export function getCumulativeExpBonus(skill, expKey) {
  const idx = EXPERIENCE_KEYS.indexOf(expKey);
  if (idx <= 0) return 0;
  let sum = 0;
  for (let i = 0; i < idx; i++) {
    sum += skill.expBonuses[i];
  }
  return sum;
}

export function getExpCap(skill, expKey) {
  const idx = EXPERIENCE_KEYS.indexOf(expKey);
  return skill.expCaps[idx] ?? 0;
}

// Calculate annual salary for a single position selection.
// Returns the center value (rounded to integer 万円).
export function calculateSalaryForPosition(skill, expKey, positionKey) {
  const posBonus = getPositionBonus(skill, positionKey);
  const posCap = getPositionCap(skill, positionKey);
  const expBonus = getCumulativeExpBonus(skill, expKey);
  const expCap = getExpCap(skill, expKey);

  const raw = skill.base + posBonus + expBonus;
  const effectiveCap = Math.min(posCap, expCap);
  const salary = Math.min(raw, effectiveCap);

  return Math.max(salary, MINIMUM_SALARY);
}

// Calculate Min-Max range for a position (center ± width).
export function getPositionRange(skill, expKey, positionKey) {
  const center = calculateSalaryForPosition(skill, expKey, positionKey);
  const width = POSITION_WIDTHS[positionKey] ?? 0;
  return {
    min: Math.max(center - width, MINIMUM_SALARY),
    max: center + width,
    center,
  };
}

// When multiple positions are selected, the overall result uses the
// position with the HIGHEST bonus (the dominant role). Ties break by
// position order (PM > PL > RD > BD > DD > IMPL > OPS > TEST).
export function getDominantPosition(skill, selectedPositions) {
  if (!selectedPositions || selectedPositions.length === 0) return null;
  let dominant = selectedPositions[0];
  let maxBonus = getPositionBonus(skill, dominant);
  for (const key of selectedPositions) {
    const bonus = getPositionBonus(skill, key);
    if (bonus > maxBonus) {
      dominant = key;
      maxBonus = bonus;
    }
  }
  return dominant;
}

// Calculate the overall Min-Max range shown as the headline.
// Uses the dominant (highest-bonus) position's range.
export function getOverallRange(skill, expKey, selectedPositions) {
  const dominant = getDominantPosition(skill, selectedPositions);
  if (!dominant) return null;
  return getPositionRange(skill, expKey, dominant);
}
